import Link from "next/link";
import { ComponentProps } from "react";
import { isExternalHref, localizePath } from "@/lib/utils";

interface LocalizedLinkProps extends ComponentProps<typeof Link> {
    lang: string;
}

export function LocalizedLink({ href, lang, children, ...props }: LocalizedLinkProps) {
    const path = href.toString();

    if (isExternalHref(path)) {
        return (
            <Link href={href} {...props}>
                {children}
            </Link>
        );
    }

    return (
        <Link href={localizePath(path, lang)} {...props} target="_top">
            {children}
        </Link>
    );
}
